var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.54191 9.40013C2.83977 10.1843 2.82467 11.3674 3.46907 12.1997C4.74782 13.8513 6.14743 15.2509 7.79899 16.5296C8.63126 17.174 9.81436 17.1589 10.5986 16.4568C12.7276 14.5505 14.6774 12.5582 16.5591 10.3688C16.7451 10.1524 16.8614 9.88715 16.8876 9.60291C17.003 8.34609 17.2403 4.72511 16.257 3.74175C15.2736 2.75839 11.6526 2.99564 10.3958 3.11112C10.1116 3.13724 9.84628 3.25361 9.62979 3.43964C7.44047 5.32131 5.44824 7.27108 3.54191 9.40013Z",
    fill: "#07862B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0499 5.99999C13.6297 5.99999 14.0998 6.47005 14.0998 7.04989C14.0998 7.62974 13.6297 8.09979 13.0499 8.09979C12.4701 8.09979 12 7.62974 12 7.04989C12 6.47005 12.4701 5.99999 13.0499 5.99999Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 11.3984L8.59979 13.4982L6.5 11.3984Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.adf1ed0e7a140d8f9d08cc78f363e943.svg";
export { ForwardRef as ReactComponent };